/**
 * @generated SignedSource<<0908202c19432611930c2b2453b0b53d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type tsAppQuery$variables = {
  offset?: number | null;
};
export type tsAppQuery$data = {
  readonly orders: ReadonlyArray<{
    readonly id: string;
    readonly lightfunnels_order_id: number;
    readonly connection_id: string;
    readonly shopify_order_id: string;
    readonly created_at: string;
    readonly connection: {
      readonly shop: {
        readonly id: string;
        readonly shop: string;
      };
    };
  }>;
  readonly connections: ReadonlyArray<{
    readonly id: string;
    readonly _id: number;
    readonly shop: {
      readonly id: string;
      readonly shop: string;
    };
    readonly funnel: {
      readonly id: string;
      readonly name: string;
    } | null;
  }>;
  readonly account: {
    readonly id: string;
    readonly shops: ReadonlyArray<{
      readonly _id: number;
      readonly id: string;
      readonly shop: string;
      readonly v2: boolean;
      readonly scopes: string;
    }>;
  };
};
export type tsAppQuery = {
  variables: tsAppQuery$variables;
  response: tsAppQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lightfunnels_order_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "connection_id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shopify_order_id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created_at",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shop",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Shop",
  "kind": "LinkedField",
  "name": "shop",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Connection",
  "kind": "LinkedField",
  "name": "connections",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v9/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Funnel",
      "kind": "LinkedField",
      "name": "funnel",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Account",
  "kind": "LinkedField",
  "name": "account",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Shop",
      "kind": "LinkedField",
      "name": "shops",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        (v2/*: any*/),
        (v7/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "v2",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scopes",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "tsAppQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "orders",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Connection",
            "kind": "LinkedField",
            "name": "connection",
            "plural": false,
            "selections": [
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tsAppQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Order",
        "kind": "LinkedField",
        "name": "orders",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Connection",
            "kind": "LinkedField",
            "name": "connection",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v10/*: any*/),
      (v11/*: any*/)
    ]
  },
  "params": {
    "cacheID": "85ff3716d72e31385322e9235f88aec4",
    "id": null,
    "metadata": {},
    "name": "tsAppQuery",
    "operationKind": "query",
    "text": "query tsAppQuery(\n  $offset: Int\n) {\n  orders(offset: $offset) {\n    id\n    lightfunnels_order_id\n    connection_id\n    shopify_order_id\n    created_at\n    connection {\n      shop {\n        id\n        shop\n      }\n      id\n    }\n  }\n  connections {\n    id\n    _id\n    shop {\n      id\n      shop\n    }\n    funnel {\n      id\n      name\n    }\n  }\n  account {\n    id\n    shops {\n      _id\n      id\n      shop\n      v2\n      scopes\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7f702d4abb27215b5d5f04b41f8a31f";

export default node;
